import { isRoleSandbox } from "@/lib/runtimeMode";
import type { SupabaseClient } from "@supabase/supabase-js";
import { createClient } from "@supabase/supabase-js";
import { timedFetch } from "./network";

let supabaseClient: SupabaseClient | null = null;

export const getSupabaseClient = () => {
  if (isRoleSandbox())
    throw new Error("Песочница не подключается к рабочей базе");
  if (!supabaseClient) {
    supabaseClient = createClient(
      import.meta.env.VITE_SUPABASE_URL,
      import.meta.env.VITE_SB_PUBLISHABLE_KEY,
      { global: { fetch: timedFetch } },
    );
  }
  return supabaseClient;
};
